import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";

import { KeyName } from "../keyName";
import TestIds from "../testIds";
import Notification from "./Notification";
import { INotification } from "./Notifications";
import { MarkAsRead, MarkAsReadWrapper, NotificationWrapper } from "./Notifications.styles";

interface IProps extends INotification {
    onClick?: (id: string) => void;
    onIsUnreadChange?: (id: string, isUnread: boolean) => void;
}

class NotificationItem extends React.PureComponent<IProps & WithTranslation> {
    handleIsUnreadClick = (): void => {
        this.props.onIsUnreadChange?.(this.props.id, !this.props.isUnread);
    };

    handleIsUnreadKeydown = (e: React.KeyboardEvent): void => {
        if ([KeyName.Enter, KeyName.Space].includes(e.key as KeyName)) {
            e.stopPropagation();
            this.handleIsUnreadClick();
        }
    };

    handleNotificationClick = (): void => {
        this.props.onClick?.(this.props.id);
    };

    render() {
        const { onClick, onIsUnreadChange, ...passProps } = this.props;
        return (
            <NotificationWrapper data-testid={TestIds.Notification}>
                <MarkAsReadWrapper>
                    <MarkAsRead $isUnread={this.props.isUnread}
                                onClick={this.handleIsUnreadClick}
                                onKeyDown={this.handleIsUnreadKeydown}
                                title={this.props.t(`Components:Notifications.${this.props.isUnread ? "MarkAsRead" : "MarkAsUnread"}`)}
                                tabIndex={0}/>
                </MarkAsReadWrapper>
                <Notification onClick={this.handleNotificationClick}
                              {...passProps} />
            </NotificationWrapper>
        );
    }
}

export default withTranslation(["Components"])(NotificationItem);